import {
    LOGIN_IN_PROGRESSA,
	LOGIN_FAILEDA,
	LOGIN_SUCCESSFULA
} from '../actions/posloginAction';

export default (state={},action)=>{
    switch(action.type){
        case LOGIN_IN_PROGRESSA:
        return true;
        case LOGIN_SUCCESSFULA:
        return action.data
        case LOGIN_FAILEDA:
        return  'wrong email or password';
        default:
        return state;
    }
}